import type { QueryClient } from "@tanstack/react-query";
import {
  getGetAnalysisGoalsQueryKey,
  getGetAssetAllocationOverviewQueryKey,
  getListContractProposalsQueryKey,
} from "Infrastructure/ApiZfp/AnalyzerApi";

/**
 * Call from the mutation options (`useMutation({ mutation: { onSuccess } })`), not from the callbacks
 * passed to `mutate()` — those are skipped when the component unmounts before the request settles.
 */
export const invalidateProposalQueries = (queryClient: QueryClient, analysisId: string, versionId: string) => {
  queryClient.invalidateQueries({ queryKey: getListContractProposalsQueryKey(analysisId, versionId) });
  queryClient.invalidateQueries({ queryKey: getGetAnalysisGoalsQueryKey(analysisId, versionId) });
  queryClient.invalidateQueries({ queryKey: getGetAssetAllocationOverviewQueryKey(analysisId, versionId) });
};
